import { useEffect, useState } from "react";
import { useWindowSize } from "@hooks/useWindowSize";

type UseDropdownListHeightProps = {
  /** The ref of the children */
  childrenRef: React.RefObject<HTMLDivElement | null>;
  /** The state of the dropdown */
  isOpen: boolean;
};

/** Custom hook to get the height of the dropdown list. */
const useDropdownListHeight = ({
  childrenRef,
  isOpen,
}: UseDropdownListHeightProps) => {
  const [childrenHeight, setChildrenHeight] = useState<number>(0);
  const windowSize = useWindowSize();

  useEffect(() => {
    if (!isOpen) return;
    if (!childrenRef.current) return;

    const height = Math.min(childrenRef.current.scrollHeight, 250);
    setChildrenHeight(height);
  }, [windowSize, isOpen, childrenRef]);

  return { childrenHeight, setChildrenHeight };
};

export default useDropdownListHeight;
